import { redirectToHomeIfNotAdmin } from '@/ccpv2/router/guards';
import {
  redirectToHomeIfNoAccess,
  redirectToHomeIfNoMyPortalAccess,
  redirectToHomeIfNoSettingsAccess,
  redirectToListIfNoSummaryAccess,
} from '@/people/router/guard';

const SummaryPage = () => import('@/people/pages/summary.vue');
const ListPage = () => import('@/people/pages/list.vue');
const EmployeePortalPage = () => import('@/people/pages/employee-portal.vue');
const EmployeePortalSettingsPage = () => import('@/people/pages/settings/employee-portal.vue');
const PeopleColumnsSettingsPage = () => import('@/people/pages/settings/columns-settings.vue');
const PeopleCustomAccessSettingsPage = () => import('@/people/pages/settings/custom-access.vue');
export const peopleRoutes = [
  {
    path: '/people/summary',
    name: 'people-summary',
    component: SummaryPage,
    beforeEnter: [redirectToHomeIfNoAccess, redirectToListIfNoSummaryAccess],
  },
  {
    path: '/people/list',
    name: 'people-list',
    component: ListPage,
    beforeEnter: redirectToHomeIfNoAccess,
  },
  {
    path: '/people/settings/employee-portal',
    name: 'people-employee-portal-settings',
    meta: { layout: 'PeopleSettingsLayout' },
    component: EmployeePortalSettingsPage,
    beforeEnter: redirectToHomeIfNoSettingsAccess,
  },
  {
    path: '/people/settings/columns',
    name: 'people-columns-settings',
    meta: { layout: 'PeopleSettingsLayout' },
    component: PeopleColumnsSettingsPage,
    beforeEnter: [redirectToHomeIfNotAdmin],
  },
  {
    path: '/people/settings/custom-access',
    name: 'people-custom-access-settings',
    meta: { layout: 'PeopleSettingsLayout' },
    component: PeopleCustomAccessSettingsPage,
    beforeEnter: [redirectToHomeIfNotAdmin],
  },
  {
    path: '/people/settings',
    name: 'people-settings',
    redirect: { name: 'people-employee-portal-settings' },
    beforeEnter: redirectToHomeIfNoSettingsAccess,
  },
  {
    path: '/people',
    name: 'people',
    redirect: { name: 'people-list' },
    beforeEnter: redirectToHomeIfNoAccess,
  },
  {
    path: '/employee-portal',
    name: 'employee-portal',
    component: EmployeePortalPage,
    beforeEnter: redirectToHomeIfNoMyPortalAccess,
  },
  {
    path: '/employee-portal/:employeeId',
    name: 'employee-portal-id',
    component: EmployeePortalPage,
    beforeEnter: redirectToHomeIfNoAccess,
  },
];
